import {Component, Prop, Vue, Mixins} from 'vue-property-decorator'
import {DateTime} from "luxon";
import {EventBus} from "@common/EventBus";
import {chooseInitDate} from "../helpers/chooseInitDate";
import {dateInOriginalOffset} from "../../../common/dateTimeHelper";
import PeriodicRefreshMixin from "../../../mixins/PeriodicRefreshMixin";
import { ProgramDataHelper } from "../helpers/ProgramDataHelper"

@Component
class ProgramMixin extends Mixins(PeriodicRefreshMixin, Vue) {
    @Prop({required: true}) eventId: string;
    @Prop({required: true}) meetingsEnabled: boolean;
    @Prop({default: false}) isWithBanner: boolean;

    static PROGRAM_REFRESH_TIMEOUT = 60 * 1000;
    static PROGRAM_ACTIVATE_LIMIT_TIMEOUT = 15 * 1000;

    scrollTo = '';
    eventsIntervalId = 0;
    eventsScrollPosition = 0;
    sessionId = '';
    meetingId = '';
    elementInFullMode = false;
    initLoading = true;

    startTimer() {
        clearInterval(this.eventsIntervalId);
        let now = DateTime.local(),
            previousMinutes = now.minute;
        this.eventsIntervalId = window.setInterval(() => {
            now = now.plus({
                seconds: 1
            });
            if (previousMinutes != now.minute) {
                const dataHelper = this.$store.getters['program/dataHelperByDate'](DateTime.local());
                if (dataHelper) {
                    dataHelper.updateAgendas();
                }
                previousMinutes = now.minute;
            }
        }, 1000);
        this.setRefreshFn(() => {
            (this as any).fetchData(null, false);
        }, ProgramMixin.PROGRAM_ACTIVATE_LIMIT_TIMEOUT);
    }

    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get calendarScrollOffset() {
        return this.isWithBanner ? 96 : 0;
    }

    get date(): DateTime | null {
        return this.$store.state.program.currentDate;
    }

    set date(date: DateTime | null) {
        this.$store.dispatch("program/updateCurrentDate", date);
    }

    async mounted() {
        if (this.eventId) {
            EventBus.$on('likeChanged', this.updateLike);
            const dates = this.$store.getters['events/selectedEventViewParam']('dates', null);
            this.date = chooseInitDate(this.$store.getters['events/selectedEvent'], this.offset, dates);
        }
    }

    subscribe() {
        EventBus.$on('meetingWebinar', this.meetingWebinar);
        EventBus.$on('newMeeting', this.newMeeting);
        EventBus.$on('eventWebinar', this.eventWebinar);
        EventBus.$on('toggleAgendaFavorite', this.toggleFavorite);
        EventBus.$on('toggleAgendaLike', this.toggleLikes);
        EventBus.$on('programMoveDateTo', this.moveDateTo);
    }

    async activated() {
        this.subscribe();
        this.startTimer();
    }

    deactivated() {
        this.unsubscribe();
        clearInterval(this.eventsIntervalId);
    }

    newMeeting(data: any = undefined) {
        this.resetForm();
        const date = data.date || this.date?.toISODate();
        this.$emit('newMeeting', {time: data.time, date: date});
    }

    resetForm(type = '') {
        if (type == 'event' || !type) {
            this.sessionId = '';
        }
        if (type == 'meeting' || !type) {
            this.meetingId = '';
        }
        this.elementInFullMode = false;

        setTimeout(() => {
            this.$refs['agenda-grid'] && (this.$refs['agenda-grid'] as any).rerender();
            // this.rerenderEvents();
        }, 350);
    }

    updateLike(data: {id: string; value: number | null}) {
        const dataHelper = this.$store.getters['program/dataHelperByAgendaId'](data.id) as ProgramDataHelper | undefined
        if (dataHelper) {
            dataHelper.updateLike(data.id, data.value)
        }
    }

    async meetingWebinar(meetingId: string) {
        this.$emit('meetingWebinar', meetingId);
    }

    async eventWebinar(eventId: string) {
        this.$emit('eventWebinar', eventId);
    }

    async toggleFavorite(agendaId: string) {
        const dataHelper = this.$store.getters['program/dataHelperByAgendaId'](agendaId);
        if (dataHelper) {
            if (dataHelper.favorites[agendaId]) {
                await dataHelper.removeFromFavorite(agendaId);
            } else {
                await dataHelper.addToFavorite(agendaId);
            }
        }
    }

    async toggleLikes(data: {id: string; value: number | null }) {
        const dataHelper = this.$store.getters['program/dataHelperByAgendaId'](data.id);
        if (dataHelper) {
            await dataHelper.toggleAgendaLike(data.id, data.value, false);

            //отправляет событие для обновления лайков в сесcии
            EventBus.$emit('update-session-likes', data);
        }
    }

    deselectSession() {
        this.resetForm();
        this.$emit('deselectSession');
    }

    moveDateTo(date: DateTime) {
        if (date) {
            this.scrollTo = date.toFormat('HH:mm');
            this.setDate(date)
        }
    }

    setDate(date: DateTime) {
        this.date = dateInOriginalOffset(date, this.offset);
    }

    unsubscribe() {
        EventBus.$off('meetingWebinar', this.meetingWebinar);
        EventBus.$off('newMeeting', this.newMeeting);
        EventBus.$off('eventWebinar', this.eventWebinar);
        EventBus.$off('toggleAgendaFavorite', this.toggleFavorite);
        EventBus.$off('toggleAgendaLike', this.toggleLikes);
        EventBus.$off('moveDateTo', this.moveDateTo);
    }

    destroyed() {
        this.unsubscribe();
        EventBus.$off('likeChanged', this.updateLike);
        clearInterval(this.eventsIntervalId);
        // EventBus.$off('participantStatusChanged', this.participantStatusChanged);
    }
}

export default ProgramMixin
